'use client';

import { useEffect, useState } from 'react';
import { Box } from '@doist/marketist';
import { useTranslation } from 'app/i18n/client';
import { MainPageHeader } from 'components/main-page-header/main-page-header';
import { SectionHeader } from 'components/SectionHeader/SectionHeader';
import { useLocale } from 'next-intl';
import { fallbacktoDefault } from '../../services/valid-platforms';
import { Actions } from '../common/actions';
import { HeroIllustration, PlatformLinks } from '../common/common';
import css from './platform-header.module.css';
import type { Platform, PlatformType } from '../../services/valid-platforms';
type HeaderProps = {
  platform: Platform;
  type?: PlatformType;
};
function isTouchDevice() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
}
function PlatformHeader({
  platform: initialPlatform,
  type: initialType
}: HeaderProps) {
  const locale = useLocale();
  const {
    t
  } = useTranslation(locale, 'downloads');
  const [platform, setPlatform] = useState<Platform>(initialPlatform);
  const [type, setType] = useState<PlatformType | undefined>(initialType);
  useEffect(() => {
    // The user agent's platform on iPad will be parsed as a Mac. So, we'll use the combination of
    // the existent of touch events and the UA parsed platform to determine a closer device approximation.
    if (initialPlatform === 'mac' && isTouchDevice()) {
      setPlatform('iPad');
      setType('tablet');
    }
  }, [initialPlatform]);
  const transKey = fallbacktoDefault.includes(platform) ? 'default' : platform;
  return <Box className={css.container} data-sentry-element="Box" data-sentry-component="PlatformHeader" data-sentry-source-file="platform-header.tsx">
            <Box className={css.header} data-sentry-element="Box" data-sentry-source-file="platform-header.tsx">
                <HeroIllustration data-sentry-element="HeroIllustration" data-sentry-source-file="platform-header.tsx" />
                <MainPageHeader size="sm" style={{
        '--top-padding': '0px'
      }} title={t(`platform.${transKey}.title`)} padded={false} data-sentry-element="MainPageHeader" data-sentry-source-file="platform-header.tsx" />
                <Actions platform={platform} type={type} data-sentry-element="Actions" data-sentry-source-file="platform-header.tsx" />
            </Box>
            <Box className={css.copy} data-sentry-element="Box" data-sentry-source-file="platform-header.tsx">
                <SectionHeader style={{
        '--gap': 'var(--space-12)'
      }} subtitle={<PlatformLinks />} title={t('platform.default.title')} data-sentry-element="SectionHeader" data-sentry-source-file="platform-header.tsx" />
            </Box>
        </Box>;
}
export { PlatformHeader };